<template>
  <div>

    <p>Test nè </p>
    <!-- Input file ẩn (được kích hoạt bởi nút @click) -->
    <input
      type="file"
      ref="fileUploader"
      @change="handleFileChange"
      accept="image/*"
    />

    <!-- Khu vực hiển thị file hiện tại (preview) -->
    <div v-if="fileData.fileId" class="image-preview-container">
      <!-- Ảnh preview chính -->
      <img
        :src="previewImageUrl"
        alt="Ảnh bài viết"
        class="current-file-image"
        @click="triggerFileUpload"
      />

      <!-- Nút Xóa Ảnh (chỉ hiển thị khi có ảnh) -->
      <button class="btn-delete-file" @click.stop="handleDeleteFile">
        <i class="fas fa-trash-alt me-1"></i> Xóa ảnh
      </button>
    </div>

    <!-- Nút chọn ảnh ban đầu -->
    <button v-else class="btn-select-file" @click="triggerFileUpload">
      <i class="fas fa-plus me-1"></i> Chọn/Tải lên ảnh (Tỉ lệ 3:2)
    </button>

    <!-- ======================================================== -->
    <!-- MODAL CROP ẢNH -->
    <!-- ======================================================== -->
    <div v-if="imageToCrop" class="cropper-modal-backdrop">
      <div class="cropper-container-box">
        <h5 class="text-center mb-3">Cắt ảnh theo tỉ lệ 3:2</h5>

        <!-- Cropper Component -->
        <Cropper
          ref="cropper"
          class="cropper-area"
          :src="imageToCrop"
          :stencil-props="{
            aspectRatio: 3 / 2, // TỈ LỆ 3:2 CHO ẢNH BÀI VIẾT
          }"
          :resize-image="{ adjustStencil: false }"
          :transitions="true"
        />

        <!-- Các nút hành động -->
        <div class="cropper-actions">
          <button class="btn-core btn-outline-core me-3" @click="cancelCrop">
            Hủy
          </button>
          <button class="btn-core btn-accept-core" @click="saveCroppedImage">
            Lưu
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import  Cropper  from "vue-advanced-cropper";

export default {
  components: {
    Cropper,
  },
  name: "ImageCroper",

  props: {
    // Đối tượng fileImage: { fileId, ext, path }
    model: {
      type: Object,
      required: true,
    },
    // URL cơ sở để xem ảnh
    baseFileViewUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      imageToCrop: null, // Chứa URL Base64/Blob để hiển thị trong cropper
      rawFile: null, // File gốc chưa xử lý
    };
  },
  computed: {
    fileData() {
      return this.model || {};
    },
    previewImageUrl() {
      return this.fileData.fileId
        ? this.baseFileViewUrl + this.fileData.fileId
        : null;
    },
  },
  watch: {
    // Theo dõi imageToCrop để mở/đóng modal cropper (dùng cho V-IF)
    imageToCrop(val) {
      if (!val) {
        // Reset input file khi cropper đóng
        if (this.$refs.fileUploader) {
          this.$refs.fileUploader.value = "";
        }
      }
    },
  },
  methods: {
    // BƯỚC 1: Kích hoạt input file ẩn
    triggerFileUpload() {
      this.$refs.fileUploader.click();
    },

    // BƯỚC 2: Xử lý khi người dùng chọn file và mở Cropper
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) {
        this.imageToCrop = null; // Đảm bảo reset nếu hủy chọn
        return;
      }

      console.log("File được chọn:", file.name, file.size); // LOG FILE

      const maxSize = 5 * 1024 * 1024; // Giả định giới hạn 5MB
      if (file.size > maxSize) {
        this.$store.dispatch("snackBarStore/addNotify", {
          data: {
            message: "Kích thước ảnh không được vượt quá 5MB.",
            code: -1,
          },
        });
        this.imageToCrop = null;
        event.target.value = ""; // Reset input
        return;
      }

      // Lưu file gốc và tạo URL Base64 để hiển thị trong cropper
      this.rawFile = file;
      const reader = new FileReader();

      reader.onload = (e) => {
        // QUAN TRỌNG: Gán kết quả Base64 vào imageToCrop
        this.imageToCrop = e.target.result;
        console.log("Cropper Modal should open now.");
      };

      // Bắt đầu đọc file dưới dạng Base64 Data URL
      reader.readAsDataURL(file);

      // Không cần reset input ở đây, nó sẽ được reset trong watch(imageToCrop)
    },

    // BƯỚC 3: Hàm lưu ảnh sau khi đã crop và gọi API
    async saveCroppedImage() {
      if (!this.$refs.cropper) return;

      const { canvas } = this.$refs.cropper.getResult();
      if (!canvas) return;

      // Xóa ảnh cũ trước khi upload ảnh mới
      if (this.fileData.fileId) {
        await this.deleteFileOnServer(this.fileData.fileId, false);
      }

      // Chuyển canvas thành Blob để gửi đi như một file
      canvas.toBlob(
        async (blob) => {
          this.imageToCrop = null; // Đóng cropper trước khi upload

          const formData = new FormData();
          const originalFileName = this.rawFile.name;
          const fileExt = originalFileName.split(".").pop() || "jpg"; // Lấy đuôi file
          const fileNameWithExt =
            originalFileName.replace(/\.[^/.]+$/, "") + `_cropped.${fileExt}`;

          formData.append("files", blob, fileNameWithExt);

          try {
            const apiUrl = `${process.env.VUE_APP_API_URL}filesminio/Upload`;
            const response = await axios.post(apiUrl, formData);
            const resultData = response.data;

            if (resultData.code === 0 && resultData.data?.fileId) {
              // Cập nhật model cha qua $emit('update:model')
              this.$emit("update:model", {
                fileId: resultData.data.fileId,
                fileName: resultData.data.fileName,
                ext: fileExt,
                path: resultData.data.path,
              });

              this.$store.dispatch("snackBarStore/addNotify", {
                data: { message: "Tải ảnh thành công!", code: 0 },
              });
            } else {
              this.$store.dispatch("snackBarStore/addNotify", {
                data: {
                  message: resultData.message || "Tải ảnh thất bại!",
                  code: -1,
                },
              });
            }
          } catch (error) {
            console.error("Lỗi upload ảnh:", error);
            this.$store.dispatch("snackBarStore/addNotify", {
              data: { message: "Đã xảy ra lỗi khi tải ảnh.", code: -1 },
            });
          }
        },
        "image/jpeg",
        0.9
      );
    },

    // BƯỚC 4: Hàm hủy crop
    cancelCrop() {
      this.imageToCrop = null; // Đóng cropper
      this.rawFile = null;
      // Reset input file để có thể chọn lại
      if (this.$refs.fileUploader) {
        this.$refs.fileUploader.value = "";
      }
    },

    // HÀM XÓA FILE TRÊN SERVER
    async deleteFileOnServer(fileId, isNotify = true) {
      try {
        await axios.post(
          `${process.env.VUE_APP_API_URL}filesminio/delete/${fileId}`
        );
        if (isNotify) {
          this.$store.dispatch("snackBarStore/addNotify", {
            data: { message: "Xóa ảnh thành công!", code: 0 },
          });
        }
        return true;
      } catch (e) {
        console.error("Lỗi xóa file:", e);
        if (isNotify) {
          this.$store.dispatch("snackBarStore/addNotify", {
            data: { message: "Lỗi khi xoá ảnh trên server.", code: -1 },
          });
        }
        return false;
      }
    },

    // HÀM XÓA ẢNH (Click nút Xóa)
    async handleDeleteFile() {
      if (!confirm("Bạn có chắc chắn muốn xóa ảnh này không?")) return;

      const fileId = this.fileData.fileId;
      if (!fileId) return;

      const success = await this.deleteFileOnServer(fileId, true);

      if (success) {
        // Cập nhật model cha qua $emit('update:model')
        this.$emit("update:model", { fileId: null, ext: null, path: null });
      }
    },
  },
};

</script>

<style scoped>
/* CSS cho component Image File Cropper */

.image-preview-container {
  margin-top: 10px;
  position: relative;
  display: inline-block;
  border-radius: 8px;
  overflow: hidden;
}
.current-file-image {
  max-width: 100%;
  height: auto;
  max-height: 200px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  cursor: pointer;
}
.current-file-image:hover {
  opacity: 0.9;
}

.btn-select-file {
  padding: 8px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s;
}
.btn-select-file:hover {
  background-color: #0056b3;
}

.btn-delete-file {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  opacity: 0.8;
  transition: opacity 0.2s;
  cursor: pointer;
}
.btn-delete-file:hover {
  opacity: 1;
}

/* Modal Cropper (Cần style chung từ file cha nếu không dùng b-modal) */
.cropper-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.cropper-container-box {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  max-width: 800px;
  width: 90%;
}
.cropper-area {
  max-height: 500px;
  background: #f0f0f0;
}
.cropper-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
/* Giả định style cho các nút Core (cần được định nghĩa global) */
.btn-core {
  padding: 8px 15px;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}
.btn-outline-core {
  background: transparent;
  border: 1px solid #6c757d;
  color: #6c757d;
}
.btn-accept-core {
  background: #28a745;
  color: white;
}
</style>
